<template>
  <textarea
    v-model="comment"
    class="rounded border block border-gray-500 text-gray-800 p-4 mb-0 focus:outline-none w-full"
    rows="10"
  />
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  data() {
    return {
      comment: '',
    };
  },
  computed: {
    ...mapState('order', ['id']),
  },
  watch: {
    comment(newVal) {
      this.setComment(newVal);
    },
  },
  methods: {
    ...mapMutations('order', ['setComment']),
  },
};
</script>
